import React from 'react';
import DocumentTitle from 'react-document-title';
import UA from '../../../utils/ua';
import './style.less';

export default function DailyAttendanceRules(props) {
    const { history } = props;
    const { state } = history.location;
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    return <DocumentTitle title="活动规则">
        <div className="DailyAttendanceRules">
        {
            state && state.ruleImg ? <img className="rules-img" src={state.ruleImg} alt="活动规则" /> : null
        }
        {UA.winClient ? <button className="btn-back" onClick={history.goBack}>返回</button> : null}
    </div>
    </DocumentTitle>
}


// WEBPACK FOOTER //
// ./src/components/dailyAttendancePage/rules/index.jsx